export const COLLAPSED_CELL_MAX_HEIGHT_PX = 40;

const LONG_TEXT_CHAR_THRESHOLD = 60;
const READABLE_TEXT_COLUMN_WIDTH = "80";

export const longTextColumnMinWidth = (
  value: string | number | boolean | null | undefined
): string | undefined =>
  typeof value === "string" && value.length > LONG_TEXT_CHAR_THRESHOLD ? READABLE_TEXT_COLUMN_WIDTH : undefined;
